import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from 'atoms/Button/Button';
import Card from 'atoms/Card/Card';
import FolderIcon from 'images/v5/3d/folder.png';
import DotsIcon from 'images/v5/icons/dots-vertical.svg';
import FileSvg from 'images/v5/icons/file-04.svg';
import FolderSvg from 'images/v5/icons/folder.svg';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import FolderOptions from 'layout/molecules/FolderOptions/FolderOptions';
import styles from './FolderCard.module.scss';
function FolderCard({ folder: { id, name, foldersCount, modelSpecificationsCount, canBeRemoved, parentId }, link, layout, }) {
    const { t } = useTranslation(['specification', 'common']);
    const folderLink = link || '/specifications/folders';
    return (React.createElement(Card, { size: "s" }, layout === 'grid' ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.tools },
            React.createElement("div", { className: styles.labels },
                React.createElement(FolderSvg, null),
                foldersCount || 0,
                React.createElement(FileSvg, null),
                modelSpecificationsCount || 0),
            React.createElement("div", { className: styles.buttons }, canBeRemoved && (React.createElement(Dropdown, { trigger: React.createElement(Button, { theme: "ghost", size: "xs", shape: "rounded", leftIcon: React.createElement(DotsIcon, null) }) },
                React.createElement(FolderOptions, { id: id, name: name, parentId: parentId }))))),
        React.createElement(Link, { to: `${folderLink}/${id}`, className: styles.link },
            React.createElement("img", { src: FolderIcon, className: styles.icon, alt: "" }),
            React.createElement("h3", { className: styles.header }, name)))) : (React.createElement("div", { className: styles.list },
        React.createElement(Link, { to: `${folderLink}/${id}` },
            React.createElement("img", { src: FolderIcon, className: styles.iconSmall, alt: "" }),
            name || '-'),
        React.createElement("p", null,
            foldersCount || 0,
            " ",
            t('folder', { count: foldersCount || 0 })),
        React.createElement("p", null,
            modelSpecificationsCount || 0,
            ' ',
            t('specification', { count: modelSpecificationsCount || 0 })),
        React.createElement("p", null,
            React.createElement(Dropdown, { trigger: React.createElement(Button, { size: "xs", shape: "rounded", theme: "ghost", leftIcon: React.createElement(DotsIcon, null) }) },
                React.createElement(FolderOptions, { id: id, name: name, parentId: parentId })))))));
}
export default FolderCard;
